@import '../../../node_modules/bootstrap/scss/functions';
@import '../../../node_modules/bootstrap/scss/variables';
@import '../../../node_modules/bootstrap/scss/variables-dark';
@import '../../../node_modules/bootstrap/scss/maps';
@import '../../../node_modules/bootstrap/scss/mixins';
@import '../../../node_modules/bootstrap/scss/reboot';
@import '../../mixins/choice-input';
@import '../../../../style/src/typography/mixins';

:host {
	@include zds-typography('body');

	color: var(--zds-text-color-base);
	display: block;
}

.choice-input {
	@include choice-input(
		$choice-input-height: 18px,
		$choice-input-padding-x: var(--zds-checkbox-inset-x),
		$choice-input-padding-y: var(--zds-checkbox-inset-y),
		$choice-input-width: 18px
	);

	display: inherit;

	&__input-graphic,
	&__input-graphic-background {
		border-radius: var(--zds-shape-radius-xs);
	}

	&__input-native:indeterminate + &__input-graphic {
		border-color: var(--zds-input-background-on);
	}

	&__input-graphic-background {
		box-shadow: inset 0 0 3px -3px var(--zds-input-background-on);
		inset: 0;
		overflow: hidden;
		position: absolute;
		transition: box-shadow var(--zds-transition-sm);

		// Checked
		.choice-input__input-native:checked + .choice-input__input-graphic & {
			box-shadow: inset 0 0 3px 9px var(--zds-input-background-on);
		}

		// Checked & invalid
		.choice-input--is-invalid .choice-input__input-native:checked + .choice-input__input-graphic & {
			box-shadow: inset 0 0 3px 9px var(--zds-input-border-color-invalid);
		}

		&::before {
			content: '';
			inset: 0;
			opacity: 0.2;
			position: absolute;
			transition: background-color var(--zds-transition-sm);

			// Hover & indeterminate
			.choice-input__input-native:indeterminate:hover + .choice-input__input-graphic & {
				background-color: var(--zds-input-background-on);
			}
		}

		&::after {
			content: '';
			inset: 0;
			position: absolute;
			transition: background-color var(--zds-transition-sm);

			// Indeterminate
			.choice-input__input-native:indeterminate + .choice-input__input-graphic & {
				background-color: var(--zds-input-background-on);
			}
		}
	}

	&__input-graphic-checkmark,
	&__input-graphic-indeterminate {
		position: absolute;

		&::after {
			content: '';
			display: flex;
			height: 100%;
			transform-origin: left top;
			transition:
				border-color var(--zds-transition-sm),
				box-shadow var(--zds-transition-sm);
			width: 100%;
		}
	}

	&__input-graphic-checkmark {
		height: 65%;
		left: 34%; // 50% - 32% / 2
		top: 17.5%; // 50% - 65% / 2
		width: 32%;
	}

	&__input-graphic-indeterminate {
		height: auto;
		left: 50%;
		top: 50%;
		width: 50%;
	}

	&__input-graphic-checkmark::after {
		border-right: 2px solid var(--zds-color-white);
		border-top: 2px solid var(--zds-color-white);
		margin-left: -3px;
		margin-top: 8px;
		transform: scaleX(-1) rotate(145deg);
	}

	&__input-graphic-indeterminate::after {
		border-bottom: 2px solid var(--zds-color-white);
		box-shadow: rgb(0 0 0 / 10%) 2px 2px 2px;
		transform: translate(-50%, -50%);
	}

	&__input-graphic &__input-graphic-indeterminate::after {
		.choice-input__input-native:checked + &,
		.choice-input__input-native:not(:checked, :indeterminate) + &,
		.choice-input__input-native:hover:not(:indeterminate) + & {
			border-color: transparent;
			box-shadow: none;
		}

		// Disable animation on page load
		.choice-input:not(.choice-input--has-loaded) .choice-input__input-native:indeterminate + & {
			animation-duration: 0ms;
		}
	}

	&__input-graphic &__input-graphic-checkmark::after {
		// Hover
		.choice-input__input-native:hover + & {
			border-color: var(--zds-color-grey-100);
		}

		// Disabled
		.choice-input__input-native:disabled + & {
			border-color: var(--zds-color-white);
		}

		// Indeterminate
		.choice-input__input-native:indeterminate + & {
			border-color: transparent;
		}

		// Checked
		.choice-input__input-native:checked:not(:indeterminate) + & {
			animation: checkmark-animation 300ms var(--zds-transition-type-ease-out);
			border-color: var(--zds-color-white);
			box-shadow: 2px -2px 2px rgb(0 0 0 / 10%);
		}

		// Disable animation on page load
		.choice-input:not(.choice-input--has-loaded) .choice-input__input-native:checked + & {
			animation-duration: 0ms;
		}
	}

	&__input-graphic &__input-graphic-checkmark--force-hover::after {
		border-color: var(--zds-selection-hover-activation);
	}
}

zds-form-label {
	display: block;
}

@keyframes checkmark-animation {
	0% {
		border-color: transparent;
	}

	60% {
		border-color: transparent;
	}

	70% {
		border-color: var(--zds-color-white);
		height: 0;
		width: 0;
	}

	85% {
		height: 0;
		width: 100%;
	}

	100% {
		height: 100%;
		width: 100%;
	}
}
